// extracted by mini-css-extract-plugin
export default {"splitFieldWrapper":"splitFieldWrapper---tOXwh","splitFieldRoot":"splitFieldRoot---jIDcL"};